<template>
    <div class="detial">
        <el-card class="box-card main-card clearfix" style="overflow: auto">

          <p style="text-align: left">{{topicDetail.title}}</p>
          <el-row>
            <div class="user">
              <i class="el-icon-user-solid"></i>
              <span style="color: #999999;font-size: 12px">{{topicDetail.createUserName}}</span>
            </div>
            <el-tag class="tag" v-for="item in  subCategoryList" :key="item.id" type="info">
                {{item.subCategoryName}}
            </el-tag>
            <span class="create-date">{{topicDetail.updateDate | formatDate}}</span>
          </el-row>

          <!--<div v-html="topicDetail.content"></div>-->
          <div id="preview"></div>
        </el-card>
    </div>
</template>
<script>
  import Vditor from 'vditor';
  import 'vditor/dist/index.css';

  export default {
  data() {
    return {
        topicDetail: {},
        subCategoryList: []
    }
  },
  mounted() {
      this.getDetail();
  },
  methods: {
      getDetail() {
          let id = this.$route.query.topicId
          this.getRequest('/tccTopic/viewDetail', {'id': id}).then(resp => {
            if (resp.status == 200) {
                if (resp.data.code == 1000) {
                this.topicDetail = resp.data.result;
                //获取该提问的回答内容
                // this.getTopicResponses();
                  const previewElement = document.getElementById('preview');
                  Vditor.preview(previewElement, this.topicDetail.content, {
                    hljs: { style: 'github' },
                  });
                var subCategoryId = this.topicDetail.subCategoryId;
                //获取标签的名称
                this.getTag(subCategoryId).then(resp =>{
                    this.subCategoryList = resp;
                });
                //获取当前标签下的推荐问题
                // this.getRecommendQuestions()
                // this.getRecommendContributes(subCategoryId)

                } else {
                Message.error(resp.data.message);
                }
            } else {
                console.error("error")
            }
        })
      },
      // 获取标签名称
      getTag(subCategoryId) {
        return this.getRequest('/tccTopic/getSubCategoryList', {'subCategoryId': subCategoryId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              return resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
  }
}
</script>
<style scoped>
 .user {
     margin-right: 20px;
     display: inline-block;
 }
 .create-date {
     margin-top: 15px;
     color: #999999;
     font-size: 12px;
     margin-left: 20px;
 }
 .main-card {
     min-height: 85vh;
 }
 </style>
